import React, { forwardRef } from "react";

import { InputHelperLabelProps } from "./InputHelperLabel.types";
import { Wrapper } from "./InputHelperLabel.styles";
import IconWrapper from "../../IconWrapper";
import Typography from "../../Typography";
import COLORS from "../../../constants/colors";

const InputHelperLabel = forwardRef<HTMLDivElement, InputHelperLabelProps>(
    (props: InputHelperLabelProps, ref) => {
        const { children, type, showIcon = true, id } = props;

        const getIconAccordingToType = () => {
            switch (type) {
                case "desc": {
                    return {
                        textColor: COLORS.GREY_500,
                        icon: null,
                    };
                }
                case "error":
                    return {
                        textColor: COLORS.RED,
                        // icon: (
                        //     <ErrorInfoIcon
                        //         fill={COLORS.RED}
                        //         width={20}
                        //         height={20}
                        //     />
                        // ),
                        icon: null,
                    };
            }
        };

        const { icon, textColor } = getIconAccordingToType();

        return (
            <Wrapper id={id}>
                {showIcon && children && icon ? (
                    <IconWrapper width={16} height={16}>
                        {icon}
                    </IconWrapper>
                ) : null}
                <Typography size="s" color={textColor}>
                    {children}
                </Typography>
            </Wrapper>
        );
    },
);

export default InputHelperLabel;
